var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('p',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('ahaDonationPromoModal'),expression:"'ahaDonationPromoModal'"}],attrs:{"href":"#"}},[_vm._v(" Open Modal")])]),_vm._v(" "),_c('aha-donation-modal',{ref:"DonationModal",attrs:{"name":"donation-modal","show-modal":true,"interval":0,"endpoint":"/aha-service/promo/PromotionalModalClosed","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}","translations":{
      btn: 'Donate Now',
      title: 'DON\'T MISS A BEAT HERE IS A SECOND LINE OF TEXT',
      description:
        'Donate now to help more families impacted by heart disease and stroke enjoy more of the holiday season TOGETHER.',
      image: '',
      video: 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0',
      url: 'url_to_make_donation',
      btn2: 'Donate Monthly',
      url2: 'url_to_make_monthly_donation',
      btnTheme: 'red',
      btnTheme2: 'white'
    }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Promo Modal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6466c7c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/promo-modal.vue
// module id = 1524
// module chunks = 0